import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './teStyle.css';
import config from '../../config.json';
import TimeEntryLabel from './TimeEntryLabel';

const apiUrl = config.apiUrl;

const TimeEntryRejected = () => {
    const [timeEntryData, setTimeEntryData] = useState({
        TransactionDate: '',
        Employee: [],
        StartDate: '',
        EndDate: '',
        Duration: '',
        EntryTypeID: '',
        Remarks: '',
        Status: '',
    });

    const { timeEntryId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchTimeEntryData = async () => {
            if (!timeEntryId) return;

            setIsDisable(true);

            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${apiUrl}/TimeEntry/${timeEntryId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch time entry data');
                    setSuccessMessage('');
                    return;
                }

                const data = await response.json();
                setTimeEntryData({
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    StartDate: data.Details.StartDate,
                    EndDate: data.Details.EndDate,
                    Duration: data.Details.Duration,
                    EntryTypeID: data.Details.EntryTypeID,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });

                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching time entry data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchTimeEntryData();
    }, []);

    const handleInputChange = (e) => {
        setTimeEntryData({ ...timeEntryData, [e.target.name]: e.target.value });
    };

    const handleForSubmit = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const { Remarks } = timeEntryData;

        const rejectTimeEntry = {
            Remarks,
        };

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/TimeEntry/Reject/${timeEntryId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(rejectTimeEntry),
            });

            const data = await response.json();

            setErrorMessage('');
            setSuccessMessage(data.Message);

            // Disable the button when the API process starts
            setIsDisable(false);

            navigate('/timeentry-list');
        } catch (error) {
            setErrorMessage('Rejected Error');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionDate,
        Employee,
        StartDate,
        EndDate,
        Duration,
        EntryTypeID,
        Remarks,
        Status,
    } = timeEntryData;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasApprover) ? (
                <>
                    <h3>Reject Time Entry</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleForSubmit}>
                        <div className="row mt-4">
                            <TimeEntryLabel label="Transaction Date" value={TransactionDate} />
                            <TimeEntryLabel label="Employee" value={Employee.Name} />
                            <TimeEntryLabel label="Time In" value={StartDate} />
                            <TimeEntryLabel label="Time Out" value={EndDate} />
                            <TimeEntryLabel label="Duration" value={Duration} />
                            <TimeEntryLabel label="Entry Type" value={EntryTypeID} />
                            <TimeEntryLabel label="Status" value={Status} />
                            <div className="mb-2">
                                <label htmlFor="remarks" className="form-label bold-label">Remarks</label>
                                <input
                                    type="text"
                                    className="form-control custom-width"
                                    id="remarks"
                                    name="Remarks"
                                    value={Remarks}
                                    onChange={handleInputChange}
                                    maxLength={255}
                                />
                            </div>
                            <div className="mb-2">
                                <Link to="/timeentry-list" className="btn btn-secondary me-2">Back</Link>
                                {(userAccess.hasApprover || userAccess.hasAdmin) && (
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isDisable}
                                    >
                                        Reject
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default TimeEntryRejected;
